module.exports = __webpack_public_path__ + "static/img/17.42a4b68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/1/sp/17.png
// module id = 5Sl8
// module chunks = 0